<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 19.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="-2 3.9 19.1 19.1" style="enable-background:new -2 3.9 19.1 19.1;" xml:space="preserve">
<g>
	<polygon points="6.3,15.7 3.5,12.7 2.4,13.8 6.4,17.9 12.8,10.3 11.7,9.3 	"/>
	<path d="M7.6,3.9C2.3,3.9-2,8.2-2,13.5s4.3,9.6,9.6,9.6s9.6-4.3,9.6-9.6S12.9,3.9,7.6,3.9z M7.6,21.6c-4.5,0-8.1-3.6-8.1-8.1
		s3.6-8.1,8.1-8.1s8.1,3.6,8.1,8.1S12.1,21.6,7.6,21.6z"/>
</g>
</svg>
